"use client"
/* */
const voidAction = () => {
};
function getExecutionFunction(action) {
  if (action.needsConfirmation) {
    return action.confirmationModalController.open;
  }
  const getOverlayController = (from) => {
    if (typeof from === "string") {
      return action.getOverlayController(from);
    }
    return from;
  };
  const {
    action: actionProp,
    onAction: actionFn = actionProp,
    toggleOverlay,
    closeOverlay,
    openOverlay
  } = action.actionProps;
  const maybeAction = actionFn ? actionFn : openOverlay ? getOverlayController(openOverlay)?.open : closeOverlay ? getOverlayController(closeOverlay)?.close : toggleOverlay ? getOverlayController(toggleOverlay)?.toggle : voidAction;
  return maybeAction ?? voidAction;
}

export { getExecutionFunction };
//# sourceMappingURL=getExecutionFunction.mjs.map
